import { createFileRoute } from "@tanstack/react-router";
import { IntegrateGoSdkPage } from "@/features/agent-integrate/pages/go-sdk-page";

// Thin shim: static SDK documentation. Snippets mirror the compiling examples in
// backend/pkg/agentsdk/example_test.go.
export const Route = createFileRoute("/_authed/tenants/$slug/agents/integrate/go-sdk")({
  component: IntegrateGoSdkPage,
});
